import { render, staticRenderFns } from "./generador_factura_proveedor.vue?vue&type=template&id=4be252c5&"
import script from "./generador_factura_proveedor.vue?vue&type=script&lang=js&"
export * from "./generador_factura_proveedor.vue?vue&type=script&lang=js&"
import style0 from "./generador_factura_proveedor.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports